import { render } from "./addblog.vue?vue&type=template&id=ae6925b2&scoped=true"
import script from "./addblog.vue?vue&type=script&lang=js"
export * from "./addblog.vue?vue&type=script&lang=js"

import "./addblog.vue?vue&type=style&index=0&id=ae6925b2&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6925b2"]])

export default __exports__